import { observable } from "mobx"
import { BookingDB } from "../../db/BookingLightDB"
import { Member } from "BookingSystem/db/Member"

export class MemberForm {
  constructor(member: Member, db: BookingDB) {
    this.member = member
    this.db = db
  }

  db: BookingDB

  @observable
  member: Member

  @observable
  wasFound = false
}
